
import { TestimonialError } from '@/exceptions/testimonial/testimonial.enum';
import { notificationService } from '@/services/notification.service';
import { testimonialService } from '@/services/testimonial.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useDeleteTestimonial = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (testimonialId: number) =>
			await testimonialService.deleteTestimonial(testimonialId),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['testimonial'] });
			notificationService.success("Testimonial deleted Succesful");

		},

		onError: () => {
			throw new Error(TestimonialError.DELETE_ERROR);
		},
	});
};

export default useDeleteTestimonial;